module.exports = __webpack_public_path__ + "static/media/my_evaluation_grey.6907ef7e.svg";